<script>
// import fullcalendar from 'vue-fullcalendar'
import OneDriverScheduleComponent from '@/components/OneDriverScheduleComponent'
import MainLayout from '@/router/layouts/mainLayout'
import {DateUtil} from '@/utils/date.js'
import {StringUtil} from '@/utils/StringUtil'
import moment from 'moment'
export default {
  created () {
    this.uid = sessionStorage.getItem('userId')
    this.driverName = sessionStorage.getItem('driverName')
    let dateStr = this.$route.query.currentDate
    if (StringUtil.isEmpty(dateStr)) {
      this.currentDate = moment().startOf('month')
      dateStr = this.currentDate.format('YYYYMM')
    } else {
      this.currentDate = moment(dateStr, 'YYYYMM').startOf('month')
    }
    // let date = new Date()
    // let dateStr = '' + date.getFullYear() + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
    this.getData(dateStr)
  },
  data () {
    return {
      uid: '',
      shiftInfoList: [],
      events: [],
      driverName: '',
      currentDate: null
    }
  },
  components: {
    OneDriverScheduleComponent,
    MainLayout
  },
  methods: {
    changeMonth (start, end, newDate) {
      this.currentDate = newDate
      this.getData(newDate.format('YYYYMM'))
    },
    getData (dateStr) {
      this.$axios.get('driver/queryDriverScheduleByUid', {params: {date: dateStr, uid: this.uid}})
        .then(response => {
          if (response.data.date === this.currentDate.format('YYYYMM')) {
            let shiftInfoList = response.data.oneDriverScheduleInfos
            let events = []
            for (let shiftInfo of shiftInfoList) {
              let moveShiftTime = DateUtil.yMd2MdW(shiftInfo.moveShiftTime)
              // 判断是否为“运行未定”状态
              let isScheduled = true
              let count = shiftInfo.shiftReservationInfos.length
              // 「運行未定」の便は「未公開」状態 ＋ 「公開中」で乗客予約が0人の場合
              if ((shiftInfo.shiftMovementStatus === 1 && shiftInfo.openFlag === 0) || (shiftInfo.shiftMovementStatus === 1 && shiftInfo.openFlag === 1 && count === 0)) {
                isScheduled = false
              } else {
                isScheduled = true
              }
              events.push({
                title: shiftInfo.title, // 标题
                start: shiftInfo.moveShiftTime.substring(0, 4) + '-' + shiftInfo.moveShiftTime.substring(4, 6) + '-' + shiftInfo.moveShiftTime.substring(6, 8),
                isOpen: isScheduled
              })
              shiftInfo.moveShiftTime = moveShiftTime
            }
            this.events = events
            this.shiftInfoList = shiftInfoList
            // console.log(this.shiftInfoList.length)
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<template>
  <MainLayout>
    <one-driver-schedule-component :events="events" :shiftInfoList="shiftInfoList" :driverName="driverName" :uid="uid" @changeMonth="changeMonth"
      style="width:99%"></one-driver-schedule-component>
  </MainLayout>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/router/views/OneDriverSchedule.vue